module.exports = __webpack_public_path__ + "d3f487b30edcf99744cc45adced05179.svg";